import {
  type ApiResponse
} from '../../api-client';

import {
  apiRequest
} from './client';

// Deliberately separate from quotes.service.ts - these hit the public,
// token-gated quote-response endpoints (no Bearer auth), not the
// authenticated dashboard ones. Mirrors payment-links.service.ts's own
// separation for the same reason.

export interface PublicQuoteLineItem {
  quoteItemName: string | null
  quoteItemDescription: string | null
  quantity: number
  unitPriceCents: number
  lineTotalCents: number
}

export interface PublicQuoteSummary {
  quoteNo: string
  customerName: string
  items: PublicQuoteLineItem[]
  totalCents: number
  currencyCode: string
  quoteStatus: string
  expiresAt: string | null
  // Set only for an already-accepted quote: a fresh link to its invoice's
  // payment page while unpaid, or invoicePaid once it is paid.
  paymentUrl?: string
  invoicePaid?: boolean
}

export async function getQuoteByRespondToken(token: string): Promise<ApiResponse<PublicQuoteSummary>> {

  return apiRequest<ApiResponse<PublicQuoteSummary>>(
    `/quotes/respond/${ encodeURIComponent(token) }`
  );
}

export async function acceptQuoteByToken(
  token: string,
  recaptchaToken: string
): Promise<ApiResponse<{ paymentUrl: string }>> {

  return apiRequest<ApiResponse<{ paymentUrl: string }>>(
    `/quotes/respond/${ encodeURIComponent(token) }/accept`,
    {
      method: 'POST',
      body: JSON.stringify({
        recaptchaToken
      })
    }
  );
}

export async function rejectQuoteByToken(
  token: string,
  rejectionReason: string,
  recaptchaToken: string
): Promise<ApiResponse<{ quoteStatus: string }>> {

  return apiRequest<ApiResponse<{ quoteStatus: string }>>(
    `/quotes/respond/${ encodeURIComponent(token) }/reject`,
    {
      method: 'POST',
      body: JSON.stringify({
        rejectionReason,
        recaptchaToken
      })
    }
  );
}
